import React, { Component, useState } from 'react';
import { updateNewPlan } from '../serverRequests/requests';

class MediaTable extends Component {
	constructor(props) {
	  super(props);
	  this.state = {
		  media: this.props.plan.media
		};
	}
	render() {
		const updateState = (state) => {
			this.setState({
				media: state
			})
			let newState = JSON.parse(JSON.stringify(this.props.plan));
			delete newState.media
			newState.media = this.state.media;
			updateNewPlan(newState)
				.then((data)=>{
					this.props.setAnimation(animationSaved=>animationSaved+1);
					console.log('Media data:', data);
					this.props.ifloorplanStateAdd(data[0]); //update state ifloorplan
				})
		}

		var heading = ['Connected Media', 'Label', 'Action'];
		return (
			<div>
				<Table heading={heading} body={this.state.media}
				setState={updateState} />
            <div className="button_group" style={{marginTop: '1%'}}>
                <button className="save" style={{marginLeft: '65%'}}
				onClick={()=> this.props.nextStep("cams position", "_")}>Done</button>
            </div>
			</div>
		);
	}
}

class Table extends Component {
	constructor(props) {
	  super(props);
	  this.state = {
		  media: this.props.body
		};
	}
	render() {
		var heading = this.props.heading;
		var body = this.state.media;

		const updateState = ({state,remove}) => {
			var mediaArray = body;
			mediaArray.map((ele) => {
				var key = mediaArray.indexOf(state)
				if(ele.id === state.id){
					if(remove === true)
						mediaArray.splice(key,1)
					else {
						let tempType = "";
						const url = new URL(state.url);
						if (url.hostname == "youtube.com" || url.hostname == "www.youtube.com" || url.hostname == "youtu.be" ){
							tempType = "youtubeVideo";
						} else if(url.hostname == "vimeo.com" || url.hostname == "www.vimeo.com" ) {
							tempType = "vimeoVideo";
						} else {
							tempType= "walk";
						}
						ele.index = key;
						ele.url = state.url;
						ele.type = tempType;
						ele.label = state.label;
					}
				}
			})
			this.setState({
				media: mediaArray
			})
			this.props.setState(state = this.state.media);
		}
		return (
			<table id='mediaTable'>
				<thead style={{borderBottom: '1px solid #877f7799'}}>
					<tr>
						{heading.map(head => <th style={{textAlign: 'left'}}>{head}</th>)}
					</tr>
				</thead>
				<tbody>
					{body.map((row) => <TableRow row={row} setState={updateState} />)}
				</tbody>
			</table>
		);
	}
}

class TableRow extends Component {
	constructor(props) {
	  super(props);
	  this.state = {
		  editVar: false,
		  media: props.row
		};
	}

	render() {
		var row = this.props.row;
		return (
			<tr>
                <td style={{textAlign: 'left', color: '#0000008f'}}>
					{this.state.editVar ?
					<input className='urlInput' type='text' value={this.state.media.url} 
					onChange={(event) => {
						this.setState({
							media: {
							...this.state.media,
							url: event.target.value
							}
						})
					}}/>
					: this.state.media.url}
				</td>
                <td style={{textAlign: 'left', fontWeight: 600}}>
					{this.state.editVar ?
					<input className='labelInput' type='text' value={this.state.media.label} 
					onChange={(event) => {
						this.setState({
							media: {
							...this.state.media,
							label: event.target.value
							}
						})
					}}/>
					: this.state.media.label}
				</td>
                <td style={{textAlign: 'left', color: '#0000008f'}}>
					<span className='editspan buttonSpan' onClick={() => {
						this.state.editVar ?
							this.props.setState({state: this.state.media,remove: false})
						: ''
						this.setState({
							editVar: !this.state.editVar
						  });
						}}
					style={this.state.editVar ?
						{fontWeight: 600, color: '#393333'} : {}}>
							{this.state.editVar ? 'Save' : 'Edit'}
					</span> | <span className='savespan buttonSpan'
					onClick={() => {
						this.props.setState({state: this.state.media,remove: true});
					}}>Remove</span>
				</td>
			</tr>
		)
	}
}

export default MediaTable;
